import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { SOCIAL_MEDIA, SOCIAL_MEDIA_ICONS } from './shareModal.constants';
import {
  CircleWrapper,
  IconsWrapper,
  ModalContent,
  Input,
  InputWrapper,
  CopyButton,
  CopyIcon,
  Title,
  IconWrapper,
  Modal,
  Anchor,
} from './shareModal.styles';
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard';
import { renderWhenTrue } from '../../utils/rendering';
import { useIntl } from 'gatsby-plugin-intl';

const Icons = ({ basicLink }) => {
  return (
    <IconsWrapper>
      {SOCIAL_MEDIA.map((name, index) => {
        return (
          <IconWrapper key={`${name}-${index}`}>
            <Anchor href={SOCIAL_MEDIA_ICONS[name].getShareLink(basicLink)} rel="noopener noreferrer" target="_blank">
              <CircleWrapper>{SOCIAL_MEDIA_ICONS[name].icon}</CircleWrapper>
            </Anchor>
            {SOCIAL_MEDIA_ICONS[name].name}
          </IconWrapper>
        );
      })}
    </IconsWrapper>
  );
};

const ShareModal = ({ modalProps, linkToShare }) => {
  const inputRef = useRef(null);
  const intl=useIntl();
  const [{ isSupported }, { copyToClipboard }] = useCopyToClipboard(inputRef);

  const renderCopyButton = renderWhenTrue(() => (
    <CopyButton onClick={() => copyToClipboard()}>
      <CopyIcon />
    </CopyButton>
  ));

  return (
    <Modal {...modalProps} styles={{ content: { height: 'auto', width: '387px', maxWidth: '95%', padding: 0 } }}>
      <ModalContent>
        <Title>{intl.formatMessage({id:'Share'})}</Title>
        <InputWrapper>
          <Input ref={inputRef} value={linkToShare} readOnly /> {renderCopyButton(isSupported)}
        </InputWrapper>
        <Icons basicLink={linkToShare} />
      </ModalContent>
    </Modal>
  );
};

ShareModal.propTypes = {
  modalProps: PropTypes.shape({
    isOpen: PropTypes.bool.isRequired,
    onRequestOpen: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
  }).isRequired,
  linkToShare: PropTypes.string.isRequired,
};

export default ShareModal;
